<template>
	<div ref="header" class="global-modal-header">
		<div class="global-modal-header__title"><slot /></div>
		<ButtonIcon class="global-modal-header__close" @click="emit('closeModal')">
			<GlobalIcon name="close-bold" :height="9"></GlobalIcon>
		</ButtonIcon>
	</div>
</template>

<script lang="ts" setup>
const emit = defineEmits<{
	(e: 'closeModal'): void
}>()
const header = ref<HTMLElement | null>(null)
const headerRef = inject<Ref<HTMLElement | null>>('headerRef') ?? ref<HTMLElement | null>(null)

watch(
	() => header.value,
	() => {
		headerRef.value = header.value
	},
)
</script>

<style lang="scss">
@import './Header';
</style>
